import React, { useState, useEffect } from "react";
import { Modal, Button } from 'react-bootstrap';
import { Input, ButtonDropdown } from '../../../../Layout/Forms/Form';
import SponsorVenuesRequests from './SponsorVenuesRequests';


const ModalSponsorVenues = ({ show, handleModalShow, handleModalhide, data, handlerBillingPlans }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [state, setState] = useState({
        form: {
            id_venues: 0,
            name: '',
            date_start: '',
            data_usage: 5
        },
        errors: []
    })

    useEffect(() => {
        setState({
            ...state,
            form: {
                ...state.form,
                id_venues: data.id_venues,
                name: data.venue_name,
            }
        })
    }, [data])


    const handleChangeInputs = (e) => {
        if (!isLoading) {
            setState({
                ...state,
                form: {
                    ...state.form,
                    [e.target.name]: e.target.value
                }
            });
        }
    }

    const handlerSelectSponsor = (data) => {
        setState({
            ...state,
            form: {
                ...state.form,
                data_usage: data
            }
        })
    }

    const handleSubmitForm = async () => {
        let info = await SponsorVenuesRequests.postSponsorVenue(state.form);
        if (info) {
            if (info.status == false) {
                if (info.errors) {
                    setState({
                        ...state,
                        errors: info.errors
                    })
                } else if (info.redirect && info.redirect === "plans") {
                    handlerBillingPlans()
                }
            } else {
                handleModalhide()
            }

        }
    }


    const Alert = () => {
        return ( typeof state.errors === 'string' || state.errors instanceof String ?
            <div className="alert alert-danger" role="alert">
                <h4 className="alert-heading">Alerta</h4>
                <p>{typeof state.errors === 'string' || state.errors instanceof String ? state.errors : ''}</p>
            </div>
        : null
        )
    }

    return (
        <>
            <Modal
                show={show}
                onHide={handleModalhide}
                dialogClassName="modal-user-access-manager-50w pb-5"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Promover Spot</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Alert />
                    <div className="row">
                        <div className="col-12">
                            <label className="form-label">Spot: &nbsp;</label>
                            <h6 className="mt-2">{data.venue_name}</h6>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-6">
                            <Input
                                label="Data início:"
                                name="date_start"
                                value={state.form.date_start}
                                onChange={(e) => handleChangeInputs(e)}
                                type="date"
                                style={{ textAlign: "center" }}
                                errors={state.errors}
                            />
                        </div>
                    </div>
                    <div className="row mt-5">
                        <div className="col-qw">
                            <div className="list-group list-group-radio d-grid gap-2 border-0">
                                <div className="position-relative">
                                    <input style={{ zIndex: 999, top: '35%' }} onChange={(e) => handlerSelectSponsor(5)} className="form-check-input position-absolute  end-0 me-3 fs-5" type="radio" name="listGroupRadioGrid" id="sponsor_5days" value="" checked={state.form.data_usage == 5 ? 'checked' : ''} />
                                    <label className="list-group-item py-3 pe-5" htmlFor="sponsor_5days" style={{ backgroundColor: '#0a1116', color: '#dee2e6' }}>
                                        <strong className="fw-semibold">Top Spot - 5 dias</strong>
                                        <span className="d-block small opacity-75">Com esta promoção o seu spot irá aparecer de forma aleatória no topo dos eventos durante 5 dias consecutivos.</span>
                                    </label>
                                </div>
                                <div className="position-relative">
                                    <input style={{ zIndex: 999, top: '35%' }} onChange={(e) => handlerSelectSponsor(10)} className="form-check-input position-absolute  end-0 me-3 fs-5" type="radio" name="listGroupRadioGrid" id="sponsor_10days" value="" checked={state.form.data_usage == 10 ? 'checked' : ''} />
                                    <label className="list-group-item py-3 pe-5" htmlFor="sponsor_10days" style={{ backgroundColor: '#0a1116', color: '#dee2e6' }}>
                                        <strong className="fw-semibold">Top Spot - 10 dias</strong>
                                        <span className="d-block small opacity-75">Com esta promoção o seu spot irá aparecer de forma aleatória no topo dos eventos durante 10 dias consecutivos.</span>
                                    </label>
                                </div>
                            </div>

                        </div>
                    </div>


                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={handleModalhide}>
                        Cancelar
                    </Button>
                    <Button variant="primary" onClick={handleSubmitForm}>
                        Seguinte
                    </Button>
                </Modal.Footer>
            </Modal >
        </>
    )
}

export default ModalSponsorVenues;